// extracted by mini-css-extract-plugin
module.exports = {"shadowed":"BaseLayout_shadowed__1g7o7","light":"BaseLayout_light__1z66x","dark":"BaseLayout_dark__2BUQc","container":"BaseLayout_container__2hXED"};